<script setup>
import { ref, computed } from 'vue'
import { store } from '@/store/appStore.js'
const search = ref(''); const divisionFilter = ref('All')
const divisions = computed(() => ['All',...new Set(store.data.products.value.map(p=>p.division))].sort())
const filtered = computed(() => {
  const q = search.value.trim().toLowerCase()
  return store.data.products.value.filter(p => (!q||p.productName.toLowerCase().includes(q)||p.sku.toLowerCase().includes(q)) && (divisionFilter.value==='All'||p.division===divisionFilter.value))
})
</script>
<template>
  <div>
    <div class="card module-header"><h2>{{ store.data.products.value.length }} SKUs</h2></div>
    <div class="card">
      <div class="toolbar">
        <input class="search-input" v-model="search" placeholder="Search product or SKU…" />
        <select class="filter-select" v-model="divisionFilter"><option v-for="d in divisions" :key="d">{{ d }}</option></select>
        <span class="result-count">{{ filtered.length }} of {{ store.data.products.value.length }} shown</span>
      </div>
      <div class="table-wrap">
        <table class="data-table">
          <thead><tr><th>SKU</th><th>Product</th><th>Brand</th><th>Pack Size</th><th>Division</th></tr></thead>
          <tbody>
            <tr v-for="p in filtered" :key="p.sku"><td class="cell-muted">{{ p.sku }}</td><td class="cell-strong">{{ p.productName }}</td><td>{{ p.brandName }}</td><td class="cell-muted">{{ p.packSize }}</td><td class="cell-muted">{{ p.division }}</td></tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
